<script setup lang="ts">
import { twMerge } from "tailwind-merge";

withDefaults(
  defineProps<{
    class?: string;
    color?: string;
    trackColor?: string;
  }>(),
  {
    color: "#214c9f",
    trackColor: "rgba(33, 76, 159, 0.3)",
  },
);
</script>

<template>
  <div
    :class="twMerge('spinner size-12', $props.class)"
    :style="{
      borderColor: trackColor,
      borderTopColor: color,
    }"
    role="progressbar"
    aria-label="Chargement en cours"
  />
</template>

<style lang="css" scoped>
.spinner {
  border: 3px solid;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
